var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPineapple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A57939",
    stroke: "#A57939",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M37.17,65.34h-1.26c-6.6,0-12-5.4-12-12V41.67c0-6.6,5.4-12,12-12h0.82c0,0,7.35,3.41,7.35,8c0,4.58,0,18,0,18v2.31 C44.08,57.98,44.5,65.34,37.17,65.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A462F",
    stroke: "#6A462F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M49.75,41.67v11.67c0,6.6-5.4,12-12,12h-0.58c7.33,0,6.91-7.36,6.91-7.36v-2.31c0,0,0-13.42,0-18c0-4.59-7.35-8-7.35-8h1.02 C44.35,29.67,49.75,35.07,49.75,41.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CC33",
    stroke: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M44.374,14.6787 c2.1344,0.044,3.8706,0.5836,3.8706,0.5836s-2.2161,2.2134-4.6058,5.5611c1.9403,0.0441,3.5029,0.5396,3.5029,0.5396 s-3.1148,3.1274-5.8109,7.4661c-1.8893,3.0393-4.5956,2.8191-4.5956,2.8191s-2.7063,0.2313-4.6058-2.8191 c-2.6961-4.3388-5.8109-7.4661-5.8109-7.4661s1.5625-0.4956,3.5029-0.5396c-2.3897-3.3476-4.6058-5.5611-4.6058-5.5611 s1.7361-0.5396,3.8706-0.5836c-2.2978-3.1275-4.3301-5.1536-4.3301-5.1536s7.9146-2.4337,10.9375,2.4336 c0.4391,0.7048,0.7762,1.3875,1.0417,2.0483c0.2553-0.6608,0.5923-1.3435,1.0315-2.0483 c3.0228-4.8673,10.9375-2.4336,10.9375-2.4336S46.6718,11.5513,44.374,14.6787z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CC33",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M43.6387,20.8234c-3.0513,1.236-3.5224,3.1594-4.3209,4.0898"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CC33",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M44.374,14.6787c0,0-4.4382,1.5439-4.6699,4.3635"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CC33",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.8562,20.8234c3.0513,1.236,3.5224,3.1594,4.3209,4.0898"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CC33",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.1209,14.6787c0,0,4.4382,1.5439,4.6699,4.3635"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M45.3047,32.3685c2.7068,2.205,4.443,5.5616,4.443,9.3041v11.6667c0,6.6-5.4,12-12,12h-1.8343c-6.6,0-12-5.4-12-12V41.6725 c0-4.0844,2.0681-7.7093,5.2089-9.8792"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M44.374,14.6787 c2.1344,0.044,3.8706,0.5836,3.8706,0.5836s-2.2161,2.2134-4.6058,5.5611c1.9403,0.0441,3.5029,0.5396,3.5029,0.5396 s-3.1148,3.1274-5.8109,7.4661c-1.8893,3.0393-4.5956,2.8191-4.5956,2.8191s-2.7063,0.2313-4.6058-2.8191 c-2.6961-4.3388-5.8109-7.4661-5.8109-7.4661s1.5625-0.4956,3.5029-0.5396c-2.3897-3.3476-4.6058-5.5611-4.6058-5.5611 s1.7361-0.5396,3.8706-0.5836c-2.2978-3.1275-4.3301-5.1536-4.3301-5.1536s7.9146-2.4337,10.9375,2.4336 c0.4391,0.7048,0.7762,1.3875,1.0417,2.0483c0.2553-0.6608,0.5923-1.3435,1.0315-2.0483 c3.0228-4.8673,10.9375-2.4336,10.9375-2.4336S46.6718,11.5513,44.374,14.6787z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M43.6387,20.8234c-3.0513,1.236-3.5224,3.1594-4.3209,4.0898"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M44.374,14.6787c0,0-4.4382,1.5439-4.6699,4.3635"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.8562,20.8234c3.0513,1.236,3.5224,3.1594,4.3209,4.0898"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.1209,14.6787c0,0,4.4382,1.5439,4.6699,4.3635"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPineapple);
export default __webpack_public_path__ + "static/media/pineapple.18db9f13983059db4b649459e8bdd53e.svg";
export { ForwardRef as ReactComponent };